// 权限管理模块
import { asyncRoutes, constRouter } from '@/router'
import {fn,_import} from '../modules/conglomerate'
import Layout from '@/layout' //布局页
import store from '../../store/index'
/**
 * 根据路由meta.role 确定是否当前用户拥有访问权限
 * @roles 用户拥有角色
 * @route 待判定路由
 *
 *
 *
*/


function hasPermission (roles,route){

    // 如果当前路由有roles 字段则需要判断用户访问权限
    if(route.meta && route.meta.roles){
        // 若用户拥有的角色中有被包含在待定路由角色表中的则拥有访问权限

        return roles.some(role => route.meta.roles.includes(role))
    } else{
        // 没有设置roles 则无需判定即可访问
        return true;
    }
}


export function newHasPermission (perms) {
	let hasPermission = false;
	// let permission = store.state.user.button_permissions;
    let permission = JSON.parse(localStorage.getItem('button_permissions'))
    // console.log(permission)
	for (var i = 0; i < permission.length; i++) {
		if(permission[i] === perms){
            // console.log('perms',perms)
			hasPermission = true;
			break;
		}
	}
	return hasPermission;
}

/**
 * 递归过滤AsyncRoutes路由表
 * @routes 待过滤路由表,首次传入的就是AsyncRoutes
 * @roles 用户拥有角色
 *
*/
export function filterAsyncRoutes(routes,roles){
    const res = []

    routes.forEach(route => {
        // 复制一份
        const tmp = { ...route}

        // 如果用户有访问权限则加入结果路由表
        if(hasPermission(roles,tmp)){
            // 如果存在子路由则递归过滤之
            if(tmp.children){
                tmp.children = filterAsyncRoutes(tmp.children,roles)
            }
            res.push(tmp)
        }
    })

    return res;
}

const state = {
    routes: [], //完整路由表
    addRoutes: [],  //用户可访问路由表
    button_permissions: []//按钮权限
}

const mutations = {
    SET_ROUTES: (state, routes) => {
        // routes 用户可以访问的权限
        state.addRoutes = routes
        // 完整的路由表
        // console.log(routes)
        // console.log(state.addRoutes)
        // console.log(constRouter)
        //牛逼
        state.routes = constRouter.concat(routes)
    },


}

const actions = {

    generateRoutes({ commit }, roles) {
        return new Promise(async resolve => {
        //
        if(localStorage.getItem('menu')){
            let permission_routes = await fn(JSON.parse(localStorage.getItem('menu')),"menu")
            var newData = [];
            permission_routes.forEach(item=>{

                newData.push({
                id:item.id,
                path: item.name,
                component: Layout, //应用布局页
            // name: 'dongtailist',
            // redirect: '/dongtailist',
                meta: {
                    title: item.title,
                    icon: item.icon,

                },
                    children:item.children
                })

            })
            newData.push({
                path: '*',
                component: () => import('@/views/errorPage/404'),
                hidden: true
            })
            permission_routes = newData;

        // console.log(permission_routes)
        //   console.log('permission_routes',permission_routes)
            // commit('SET_ROUTES',accessedRoutes)
            commit('SET_ROUTES',permission_routes)

            // resolve(accessedRoutes)
            resolve(permission_routes)
        }
        //    let accessedRoutes = asyncRoutes;
        //     // 用户是管理员则拥有完整访问权限
        //     if(roles.includes('admin')){
        //         accessedRoutes = asyncRoutes || []
        //     }else{
        //         // console.log(roles)
        //         //  否则需要根据用户角色做过滤处理 jerry
        //         accessedRoutes = filterAsyncRoutes(asyncRoutes,roles)
        //     }
        // //   console.log('permission_routes',permission_routes)
        //   commit('SET_ROUTES',accessedRoutes)
        // // //   commit('SET_ROUTES',permission_routes)

        //   resolve(accessedRoutes)
        //   resolve(permission_routes)
            // console.log('permission_routes',permission_routes)
        // console.log(this.permission_routes)
        })

    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
